module.exports = __webpack_public_path__ + "static/img/banner.d91f0e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/entry/img/banner.png
// module id = eZS8
// module chunks = 1